angular.module('app').directive("pageNameAutocomplete", ["pagesService", '$timeout', 'errorHandler', function (pagesService, $timeout, errorHandler) {
    return {
        restrict: 'E',
        replace: 'true',
        templateUrl: "views/templates/page_name_autocomplete/page_name_autocomplete.html",
        link: function ($scope, element, attr) {
            $scope.showSearchResults = false;
            var selectedSearchTerm;
            $scope.searchTerm = "";
            var originalNames;
            $scope.names = [];
            $scope.actualPageNames = $scope.actualPageNames || [];
            $scope.autocomplete = $scope.autocomplete || {};
            $scope.autocomplete.updateOriginalNames = function updateOriginalNames() {
                    originalNames = $scope.actualPageNames.filter(function filterNames(item) {
                        return !$scope.usedNames[item.id] || ($scope.pageData.name && $scope.pageData.name === item.name);
                    }).map(function mapNames(item) {
                        return {
                            value: item.name
                        };
                    });

            };

            $scope.autocomplete.updateOriginalNames();

            /**
             * Select page name
             * @param game
             */
            $scope.selectPageName = function selectPageName(name) {
                name = name.value || name;
                $scope.searchTerm = name;
                $scope.pageData.name = name;
                $scope.showSearchResults = false;
                selectedSearchTerm = name;
                $timeout(function () {
                    $scope.$apply();
                })
            };

            if ($scope.pageData.name) {
                $scope.selectPageName($scope.pageData.name);
            }


            function doSearch(term) {
                if(term !== selectedSearchTerm) {
                    $scope.pageData.name = "";
                }
                if (term !== selectedSearchTerm) {
                    $scope.names = originalNames.filter(function filterNames(item) {
                        return !term || item.value.toLowerCase().indexOf(term) === 0;
                    });
                    $scope.showSearchResults = true;
                } else {
                    $scope.showSearchResults = false;
                }

            }

            /**
             * Monitors search field and starts searching when user stopped typing
             */
            var currentSearchTermValue, searchWatcherPromise;

            function searchWatcher() {
                if ($scope.searchTerm && currentSearchTermValue !== $scope.searchTerm) {
                    currentSearchTermValue = $scope.searchTerm;
                    if (searchWatcherPromise) {
                        $timeout.cancel(searchWatcherPromise);
                    }
                    searchWatcherPromise = $timeout(searchWatcher, 100);
                } else {
                    doSearch($scope.searchTerm);
                }


            }


            /**
             * performs the search when keypress event is 'enter'(13)
             * @param event
             */
            $scope.searchEnter = function searchEnter(event) {
                if (event.which === 13) {
                    searchWatcher();
                }
            };

            function arrowDownListener() {
                if ($scope.names.length) {
                    var highlightedElements = $scope.names.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        var item = highlightedElements[0];
                        item.isHighlighted = false;
                        var index = $scope.names.indexOf(item);
                        if (index < $scope.names.length - 1) {
                            $scope.names[index + 1].isHighlighted = true;
                        } else {
                            $scope.names[0].isHighlighted = true;
                        }
                    } else {
                        $scope.names[0].isHighlighted = true;
                    }
                    $timeout(function () {
                        $scope.$apply();
                    })
                }
            }

            function arrowUpListener() {
                if ($scope.names.length) {
                    var highlightedElements = $scope.names.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        var item = highlightedElements[0];
                        item.isHighlighted = false;
                        var index = $scope.names.indexOf(item);
                        if (index > 0) {
                            $scope.names[index - 1].isHighlighted = true;
                        } else {
                            $scope.names[$scope.names.length - 1].isHighlighted = true;
                        }
                    }
                    $timeout(function () {
                        $scope.$apply();
                    })
                }
            }

            /**
             * Searching game selecting by enter listener
             */
            function enterListener() {
                if ($scope.names.length) {
                    var highlightedElements = $scope.names.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        $scope.selectPageName(highlightedElements[0]);
                    }
                }
            }




            function keyDownListener(event) {
                var keyCode = event.keyCode;
                if (keyCode === 38) {
                    arrowUpListener();
                } else if (keyCode === 40) {
                    arrowDownListener();
                } else if (keyCode === 13) {
                    event.preventDefault();
                    enterListener();
                }
            }

            document.body.addEventListener('keydown', keyDownListener);
            $scope.$on("$destroy", function (event) {
                document.body.removeEventListener('keydown', keyDownListener);
            });



            $scope.nameValidation = {pageName: 'validationErrorMessages.namePatternMsg'};

            /**
             * Name change listener
             */
            $scope.nameChangeListener = function () {
                $timeout(function () {
                    if ($scope.searchTerm && $scope.searchTerm.length > 0) {
                        if (!/^[a-zA-Z0-9 \_\-]+$/.test($scope.searchTerm)) {
                            $scope.searchTerm = $scope.searchTerm.replace(/[^a-zA-Z0-9 \_\-]/g, '');
                        } else  {
                            $scope.searchTerm = $scope.searchTerm.toLowerCase();
                            $scope.searchTerm = $scope.searchTerm.replace(/ |\_/g, '-');
                        }
                    }
                    searchWatcher();
                    $scope.$apply();
                })

            };
            /**
             * Name paste listener
             */
            $scope.namePasteListener = function namePasteListener($event) {
                $event.preventDefault();
                var value = $event.originalEvent.clipboardData.getData('text/plain');
                if (value && value.length > 0) {
                    if (/^[a-zA-Z0-9 \_\-]+$/.test(value)) {
                        value = value.toLowerCase();
                        $scope.searchTerm =  value.replace(/ |\_/g, '-');
                    }
                }
                searchWatcher();
                $timeout(function () {
                    $scope.$apply();
                })
            };

            /**
             * Set page data name when blur input
             */
            $scope.nameBlurListener = function nameBlurListener() {
                $scope.pageData.name = $scope.searchTerm;
            };

            $scope.nameFocusListener = function nameFocusListener() {
                searchWatcher();
            };

            /**
             * Init page name autocomplete
             */
            $scope.autocomplete.initPageNameAutocomplete = function initPageNameAutocomplete() {
                $scope.searchTerm = "";
                $scope.showSearchResults = false;
                selectedSearchTerm = undefined;
            }

        }

    };
}]);